export const Gender = {
  MALE: '남',
  FEMALE: '여',
} as const;
